import React, { Component } from "react";
import { injectIntl } from "react-intl";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { Maximize2, Minimize2 } from "lucide-react";

import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";

import OutletImg from '../../assets/css/img/CarWashCenter.png';
import {
  changeLocale,
  clickOnMobileMenu,
  logoutUser,
  setContainerClassnames,
} from "../../redux/actions";
import { SetActiveItem } from "../../redux/activeItem/actions";
import { setSearch } from "../../redux/settings/actions";


import { MobileMenuIcon } from "../../components/svg";
import { auth } from '../../helpers/Firebase';
import { accessTypes, accessTypesObject } from "../../helpers/Utils";
// import TopnavNotifications from "./Topnav.Notifications";

class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInFullScreen: false,
    };
  }


  isInFullScreen = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };
  componentWillMount() {

    // auth().onAuthStateChanged(user => {
    //   if (user) {
    //     user.getIdTokenResult(true).then(result => {
    //       let { role } = result.claims
    //       if (["admin", "superAdmin"].includes(role)) {
    //         let post = {
    //           email: user.email,
    //           uid: user.uid,
    //           displayName: user.displayName,
    //           accessType: role,
    //           phoneNumber: user.phoneNumber
    //         }
    //         this.props.loginUserSuccess(post)
    //       } else {
    //         this.props.logoutUser(this.props.history);

    //       }

    //     })
    //   }
    // })
  }


  toggleFullScreen = () => {
    const isInFullScreen = this.isInFullScreen();

    var docElm = document.documentElement;
    if (!isInFullScreen) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    this.setState({
      isInFullScreen: !isInFullScreen
    });
  };

  handleLogout = () => {
    auth().signOut().then(() => {
      window.location.reload()
    })

  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    e.preventDefault();

    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };
  mobileMenuButtonClick = (e, containerClassnames) => {
    e.preventDefault();
    this.props.clickOnMobileMenu(containerClassnames);
  };

  render() {
    const { containerClassnames, authUser, provider, bookings } = this.props;
    return (
      <nav className="navbar fixed-top">

        <div className="d-flex align-items-center navbar-left">

          {/* <NavLink
            to="#"
            className="menu-button d-none d-md-block"
            onClick={e =>
              this.menuButtonClick(e, menuClickCount, containerClassnames)
            }
          >
            <MenuIcon />
          </NavLink> */}
          <NavLink
            to="#"
            className="menu-button-mobile mobile-menu-toggle d-md-none"
            onClick={e => {
              e.preventDefault();
              // Try to toggle modern sidebar if available
              if (window.toggleModernSidebar) {
                window.toggleModernSidebar();
              } else {
                // Fallback to old sidebar behavior
                this.mobileMenuButtonClick(e, containerClassnames);
              }
            }}
          >
            <MobileMenuIcon />
          </NavLink>
          {bookings?.filter(b => b.delayed)?.length ?
            <NavLink
              to="/app/orders/appointments"
              style={{ textDecoration: 'none' }}
              onClick={() => {
                this.props.SetActiveItem && this.props.SetActiveItem(false);
                this.props.setSearch && this.props.setSearch("");
              }}
            >
              <Button color='danger' size='sm'>
                {`${bookings?.filter(b => b.delayed)?.length} Appointments(s) Needs Your Attention`}
              </Button>
            </NavLink>
            : ''}

        </div>
        <a className="navbar-logo" href="/">
          <span className="logo d-none d-xs-block" />
          <span className="logo-mobile d-block d-xs-none" />
        </a>
        <div className="navbar-right">

          <div className="header-icons">

            {/* <TopnavNotifications /> */}
            <button
              className="header-icon d-none d-sm-inline-block"
              type="button"
              id="fullScreenButton"
              onClick={this.toggleFullScreen}
            >
              {this.state.isInFullScreen ? (
                <Minimize2 size={18} />
              ) : (
                <Maximize2 size={18} />
              )}
            </button>
          </div>
          <div className="user">
            <UncontrolledDropdown className="dropdown-menu-right">
              {
                (accessTypes.includes(authUser?.user?.accessType) ?
                  <DropdownToggle color="empty">
                    <span className="name">{authUser.user.displayName}</span>
                    <span className="name">{'( ' + accessTypesObject?.[authUser?.user?.accessType]?.name + ' )'}</span>
                    <img alt="Profile" src={OutletImg} />
                  </DropdownToggle> :
                  <DropdownToggle color="empty">
                    <span className="name">{authUser.user.accessType === 'admin' && provider && Object.values(provider)[0]?.name}</span>
                    <span className="name">{'( ' + accessTypesObject?.[authUser?.user?.accessType]?.name + ' )'}</span>
                    <img alt="Profile" src={authUser.user.accessType === 'admin' && provider && Object.values(provider)[0]?.pictures && Object.values(provider)[0]?.pictures[0] ? Object.values(provider)[0]?.pictures[0] : OutletImg} />
                  </DropdownToggle>)
              }

              <DropdownMenu right>
                {/* <DropdownItem>Account</DropdownItem>
                <DropdownItem>Features</DropdownItem>
                <DropdownItem>History</DropdownItem>
                <DropdownItem>Support</DropdownItem>
                <DropdownItem divider /> */}
                {authUser.user.accessType === "superAdmin" && <>
                  <Link to={"/app/admins"} onClick={() => { }
                  }>
                    <DropdownItem >
                      {/* <i className={sub.icon} />{" "} */}
                      Users and permissions

                    </DropdownItem>
                  </Link>

                  <DropdownItem divider />
                </>}
                <DropdownItem onClick={() => this.handleLogout()}>
                  Sign out
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = ({ menu, settings, authUser, providers }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  const { locale } = settings;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    locale,
    authUser,
    provider: providers ? providers.provider : {},
    bookings: providers ? providers.bookings : {},
  };
};
export default injectIntl(
  connect(
    mapStateToProps,
    { setContainerClassnames, clickOnMobileMenu, logoutUser, changeLocale, SetActiveItem, setSearch }
  )(TopNav)
);
